// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NQ0E","right":"styles_right__3nYFX"};